import './Privacy.css';
const Para=(props)=>{
    return(
        <div className="Parah">
        <p>{props.para}</p>
        </div>
    );
};

export default Para;